/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Analysis_IntroInputs */

const en_gc_guides_analysis_intro = /** @type {(inputs: Gc_Guides_Analysis_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A table is good at keeping records; a summary helps you notice a pattern. Charts compare values visually, while PivotTables group repeated categories without changing the original records. Start with a small question, such as which region has the highest total, before adding more fields or formatting.`)
};

const zh_gc_guides_analysis_intro = /** @type {(inputs: Gc_Guides_Analysis_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表格擅长保存记录，汇总则帮助你发现规律。图表用视觉比较数值，数据透视表在不改变原记录的前提下汇总重复分类。先从“哪个地区合计最高”这样的简单问题开始，再添加字段或格式。`)
};

/**
* | output |
* | --- |
* | "A table is good at keeping records; a summary helps you notice a pattern. Charts compare values visually, while PivotTables group repeated categories without..." |
*
* @param {Gc_Guides_Analysis_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_analysis_intro = /** @type {((inputs?: Gc_Guides_Analysis_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Analysis_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_analysis_intro(inputs)
	return zh_gc_guides_analysis_intro(inputs)
});
export { gc_guides_analysis_intro as "gc.guides.analysis.intro" }